import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { Button, Box, Dialog, DialogTitle, DialogActions, DialogContent, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useSetUserGridMutation } from "../../../../middleware/usersApi";
import FormItem from "../../FormItem";

export const ModalSelectColumnsServer = ({ open, setOpen, data, nameStorage, config, refetch }) => {
  const { t } = useTranslation();

  const { control, handleSubmit, reset } = useForm();
  const [setGridMutation] = useSetUserGridMutation();

  const onSubmit = async (data) => {
    const columnsData = Object.entries(data).map(([name, value]) => ({
      name,
      visible: value,
    }));
    setGridMutation({ name: nameStorage, columnSettings: columnsData }).then((result) => {
      if ("error" in result) {
        return;
      }
      refetch();
      handleClose();
    });
  };

  const handleClose = () => {
    setOpen(false);
  };

  const getDividedConfig = (array) => {
    const middle = Math.round(array.length / 2);
    return array.reduce(
      (acc, item, i) => {
        i < middle ? acc[0].push(item) : acc[1].push(item);
        return acc;
      },
      [[], []]
    );
  };

  useEffect(() => reset(data), [data, reset]);

  return (
    <Dialog open={open} onClose={handleClose} className="modal select_columns" maxWidth="md">
      <DialogTitle className="modal-title-between border_bottom">
        <Typography className="modal-title">{t("title:select_fields_header")}</Typography>
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ padding: "0 36px" }}>
        <form id="formModalSelect" className="modal select_columns-form" onSubmit={handleSubmit(onSubmit)}>
          {getDividedConfig(config).map((item, i) => (
            <Box key={i} sx={{ minWidth: "250px", display: "flex", flexDirection: "column", gap: "16px" }}>
              {item.map(({ name, label, input, ...rest }, i) => (
                <FormItem key={i} control={control} name={name} label={label} input={input} {...rest} />
              ))}
            </Box>
          ))}
        </form>
      </DialogContent>
      <DialogActions className="btn btn-white">
        <Button className="btn btn-outlined-grey" onClick={handleClose}>
          {t("button:comeback")}
        </Button>
        <Button form="formModalSelect" className="btn btn-primary-fill" type="submit" autoFocus>
          {t("button:apply")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
